var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-radio-group',{attrs:{"item-list":_vm.buildTemplateListForRadioSelector,"selected-value":_vm.selectedPdfTemplate,"value-key":"templateKey","label-key":"templateName","hide-details":true},on:{"onChangeValue":function($event){_vm.selectedPdfTemplate = $event.newValue}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce96f6ba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/shared/assessment-share/PdfTemplateSelectorRadioGroup.vue
// module id = null
// module chunks = 